/**
 * Hook for communicating with the parent Ionic app when the PWA is loaded inside an iframe.
 * See frontend/PARENT_APP_IFRAME.md for the full postMessage contract.
 */

import { PARENT_APP_ORIGIN, detectIframe, requestTokenFromParent } from '../utils/parentAppBridge';

export function useParentApp() {
  const isInsideIframe = detectIframe();

  const navigateToRockease = () => {
    globalThis.parent.postMessage({ type: 'CLOSE_SECONDE_VIE' }, PARENT_APP_ORIGIN);
  };

  const requestShare = async (shareData: {
    title?: string;
    text?: string;
    url?: string;
    files?: File[];
  }) => {
    const { files, ...rest } = shareData;

    let serializedFiles: { dataUrl: string; mimeType: string; name: string }[] | undefined;
    if (files && files.length > 0) {
      serializedFiles = await Promise.all(
        files.map(async file => {
          const dataUrl = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
          return { dataUrl, mimeType: file.type, name: file.name };
        })
      );
    }
    console.log('Posting SHARE_REQUEST to parent app with data:', {
      ...rest,
      files: serializedFiles,
    });
    globalThis.parent.postMessage(
      { type: 'SHARE_REQUEST', ...rest, ...(serializedFiles ? { files: serializedFiles } : {}) },
      PARENT_APP_ORIGIN
    );
  };

  const requestDownload = (url: string, filename: string, token: string) => {
    globalThis.parent.postMessage(
      { type: 'DOWNLOAD_REQUEST', url, filename, token },
      PARENT_APP_ORIGIN
    );
  };

  const requestShareVia = (
    channel: string,
    shareData: { title?: string; text?: string; url?: string }
  ) => {
    globalThis.parent.postMessage(
      { type: 'SHARE_VIA', channel, ...shareData },
      PARENT_APP_ORIGIN
    );
  };

  const requestPhoneCall = (phoneNumber: string) => {
    globalThis.parent.postMessage({ type: 'PHONE_CALL', phoneNumber }, PARENT_APP_ORIGIN);
  };

  return {
    isInsideIframe,
    navigateToRockease,
    requestShare,
    requestShareVia,
    requestDownload,
    requestPhoneCall,
    requestTokenFromParent,
  };
}
